import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/Const";
import { useAuth } from "../authentication/AuthContext";
import "../Login&Register/LoginRegister.css";
import { toast, ToastContainer } from "react-toastify";
import { getDeviceFingerprint } from "../../utils/fingerprint";

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, user, loading } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!loading && isAuthenticated && user) {
      const role = user.role;
      const registrationType = user.registrationType;
      if (role === 2) {
        navigate("/superadmindashboard");
      } else if (user.isStaff && user.staffRole === "chef") {
        navigate("/kds");
      } else if (registrationType === "store") {
        navigate("/select-place");
      } else {
        navigate("/table");
      }
    }
  }, [isAuthenticated, user, loading, navigate]);

  const [formData, setFormData] = useState({
    emailOrMobile: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

    const handleInputFocus = () => {
      toast.dismiss();
    };


  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    setIsSubmitting(true);
    // form validation
        if (!formData.emailOrMobile.trim()) {
          toast.error("Email or Mobile No. is required!");
          setIsSubmitting(false);
          return;
        }
    
        if (formData.password.trim() === "") {
          toast.error("Please enter your password!");
          setIsSubmitting(false);
          return;
        }
       else{
          try {
            const deviceInfo = getDeviceFingerprint();
            const response = await axios.post(`${baseUrl}login`, {
              ...formData,
              deviceInfo,
            });
            const { token, user, sessionId } = response.data;
            const registrationType = user.registrationType;
            const role = user.role;
  
            localStorage.setItem("token", token);
            if (sessionId) {
              localStorage.setItem("sessionId", sessionId);
            }
            localStorage.setItem("registrationType", registrationType);
            login(token);
            if (role === 2) {
              navigate("/superadmindashboard");
            } else if (user.isStaff && user.staffRole === "chef") {
              navigate("/kds");
            } else if(registrationType === "store") {
              navigate("/select-place");
            } else {
              navigate('/table');
            }
          } catch (error) {
            toast.error(error.response?.data?.msg || "Invalid credentials");
            console.error("Error:", error);
          }
        }
    setIsSubmitting(false);
  };

  return (
    <div className="img2">
      <ToastContainer />
      <div className="flex justify-center z-[1] items-center h-screen">
        <div className="backdrop-blur-[2px]">
          
          <form
            onSubmit={handleSubmit}
            className="bg-gradient-to-br from-[#FFF8F0] to-[#F8F3E9] border-2 border-[#E6B17E] shadow-xl rounded-2xl px-8 py-2 max-w-md w-full"
          >
            {/* Logo/Title Section */}
            <div className="text-center mb-2">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-[#D35400] to-[#E67E22] rounded-full mb-4 shadow-lg">
                <span className="text-3xl text-white font-bold">CR</span>
              </div>
              <p className="text-3xl font-bold bg-gradient-to-r from-[#D35400] to-[#E67E22] bg-clip-text text-transparent">
                CloudRasoi
              </p>
              <p className="text-sm text-[#7E6B5A] mt-2">Restaurant Management System</p>
            </div>

            <p className="text-xl font-bold mb-4 text-center text-[#2C3E50] border-b-2 border-[#E6B17E] pb-3">
              Store Login
            </p>
            
            <div className="mb-6">
              <label className="block text-[#5D4037] text-sm font-semibold mb-2">
                Email or Mobile No.
              </label>
              <input
                type="text"
                name="emailOrMobile"
                placeholder="Enter Your Email or Mobile No."
                onChange={handleChange}
                onFocus={handleInputFocus}
                className="w-full p-2 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
              />
            </div>

            <div className="mb-3">
              <div className="flex justify-between items-center mb-2">
                <label className="block text-[#5D4037] text-sm font-semibold">
                  Password
                </label>
                <Link 
                  to="/ForgotPassword" 
                  className="text-xs font-bold text-[#D35400] hover:text-[#E67E22] hover:underline transition-colors duration-300"
                >
                  Forgot Password?
                </Link>
              </div>
              <input
                type="password"
                name="password"
                placeholder="Enter Password"
                onChange={handleChange}
                onFocus={handleInputFocus}
                className="w-full p-2 rounded-lg border-2 border-[#D7CCC8] bg-white text-[#5D4037] placeholder-[#A1887F] focus:outline-none focus:border-[#E67E22] focus:ring-2 focus:ring-[#E67E22]/30 transition-all duration-300"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#D35400] to-[#E67E22] hover:from-[#E67E22] hover:to-[#D35400] text-white font-bold py-3.5 px-4 rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#E67E22] focus:ring-offset-2 disabled:opacity-70 disabled:cursor-not-allowed"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg className="animate-spin h-5 w-5 mr-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                'Login to Dashboard'
              )}
            </button>

            <div className="mt-4 pt-2 border-t border-[#D7CCC8]">
              <p className="text-center text-[#7E6B5A]">
                Don't have an account?{" "}
                <Link
                  to="/register"
                  className="font-bold text-[#D35400] hover:text-[#E67E22] hover:underline underline-offset-2 transition-colors duration-300"
                >
                  Register Your Restaurant
                </Link>
              </p>
            </div>

            {/* Additional Info */}
            <div className="mt-2 text-center">
              <p className="text-xs text-[#A1887F]">
                By logging in, you agree to our{" "}
                <Link to="/terms" className="text-[#D35400] hover:underline">
                  Terms
                </Link>{" "}
                and{" "}
                <Link to="/privacy" className="text-[#D35400] hover:underline">
                  Privacy Policy
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;